<nb-card [size]="breakpoint.width >= breakpoints.xxxl || breakpoint.width < breakpoints.md ? 'large' : 'xlarge'">
  <nb-tabset fullWidth>
    <nb-tab tabTitle="Kontahenci">
      <div class="contact" *ngFor="let c of contacts">
        <nb-user [picture]="c.user.picture" [name]="c.user.name" [title]="c.type" size="large"></nb-user>
      </div>
    </nb-tab>
    <nb-tab tabTitle="Konczące się umowy">
      <div class="contact" *ngFor="let c of recent">
        <nb-user [picture]="c.user.picture" [name]="c.user.name" [title]="c.type" size="large"></nb-user>
        <span class="time">{{ c.time }}</span>
      </div>
    </nb-tab>
  </nb-tabset>
</nb-card>
